import { render, staticRenderFns } from "./BuyList.vue?vue&type=template&id=1ea93030&scoped=true&"
import script from "./BuyList.vue?vue&type=script&lang=js&"
export * from "./BuyList.vue?vue&type=script&lang=js&"
import style0 from "./BuyList.vue?vue&type=style&index=0&id=1ea93030&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea93030",
  null
  
)

export default component.exports